import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";


interface iMyBalanceState {
    user_id : string;
    credit : number;
    held_credit : number;
    updated_at_iso : string;
}

export interface iUserMyBalanceState {
    response : iMyBalanceState | null;
    isLoading : boolean;
    message : string | null;
}

const initialState : iUserMyBalanceState = {
    response : null,
    isLoading : false,
    message : null,
}

export const getUserMyCreditBalanceAPI = createAsyncThunk(
    "GET_USER_MY_BALANCE",
    async (_, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/A7fQ9K2mXcP4R8sL/user/my-balance/';
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}`);
            return response.data;
        } catch (e) {
            console.error('User My Balance API 에러:', e);
            return rejectWithValue(e.response ? e.response.data : e.message);
        }
    }
)

export const userMyCreditBalanceSlice = createSlice({
    name : "userMyCreditBalance",
    initialState,
    reducers : {},
    extraReducers : (builder) => {
        builder
        .addCase(getUserMyCreditBalanceAPI.pending, (state) => {
            state.isLoading = true;
            state.message = null;
        })
        .addCase(getUserMyCreditBalanceAPI.fulfilled, (state, action) => {
            state.isLoading = false;
            state.response = action.payload;
        })
        .addCase(getUserMyCreditBalanceAPI.rejected, (state, action) => {
            state.isLoading = false;
            state.message = action.payload as string;
        })
    }
})

export default userMyCreditBalanceSlice.reducer;

